import Vue from "vue"

Vue.filter('shorten', function (value, length) {
	if (length === undefined) { var length = 180}

	if(value.length > length) {
	    value = value.substring(0,length-3)+"...";
	}
  	return value;
})

Vue.filter('formatAddress', function (obj, type) {
	if (obj["locality"] == undefined) return "Keine Angabe";

	if (type === undefined) { var type = "employers"}

	var output = "";

    if (obj["route"] != undefined && type == "employers") {
        output += obj["route"];
    }

    if (obj["street_number"] != undefined && type == "employers") {
        output += " " + obj["street_number"];
    }

    if (obj["route"] != undefined && type == "employers") {
        output += ",";
    }


    if (obj["postal_code"] != undefined) {
        output += " " + obj["postal_code"];
    }

    if (obj["locality"] != undefined) {
        output += " " + obj["locality"];
    }
    return output;
})


var createName = function(obj) {
    
}


// WEBPACK FOOTER //
// ./src/utils/filters.js